import Home from "./Home";
import Header from "./Header";
import Footer from "./Footer";
import FrontPage from "./FrontPage";
import TableOfContents from "./TableOfContents";
import { Artwork, Artwork2, Artwork3 } from "./Artwork";
import { CodingProjects, CodingProjects2, CodingProjects3, CodingProjects4, CodingProjects5 } from "./CodingProjects";
import Writing from "./Writing";
import { About, About2 } from "./About";
import BackPage from "./BackPage";
import BackCover from "./BackCover"
import { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { LeftPage, RightPage } from "./Footer";
//import { windowHeight, windowWidth } from "./PageAnimations";
import BookofAbdulFrontLogo from "./photos/BookDecorWebP/BookofAbdul_Logo(FrontCoverV2).webp";
import BookofAbdulBackLogo from "./photos/BookDecorWebP/BookofAbdul_Logo(BackCoverV2).webp";

export let windowWidth = window.innerWidth;
export let windowHeight = window.innerHeight;

/**
The main App component.

@function

@returns {JSX.Element} The rendered App component.
*/

function App() {

  /* Preventing users from pressing back on the browser 
  in order to use header and footer buttons to navigate book.
  Inspired by this approach: 
  https://www.thecoderscamp.com/disabling-back-button-in-react-with-react-router-v6/ */

  const location = useLocation();
  const navigate = useNavigate();
  console.debug("Location from App: " + location.pathname);

  useEffect(() => {
    window.history.pushState(null, document.title, location.pathname);
    console.debug("Location useEffect: " + window.location.href);
    window.addEventListener("popstate", handleBackButton);
    
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    }
  });
  
  const handleBackButton = () => {
    //console.debug("Location from App back: " + window.location.pathname);
    alert("Please use the buttons provided to navigate the contents of the book.");
    window.history.pushState(null, document.title, location.pathname);
    //window.history.pushState(null, document.title, location.pathname);
  }

  /* Detecting whether user enters website through typing URL in browser,
  and redirecting to homepage if done so. This is to preserve the state of 
  the website. */
  useEffect(() => {
    if ((document.referrer === "" && location.pathname !== "/")
      && LeftPage.GetPage === 0 && RightPage.GetPage === 0) {
        console.debug("User came directly through non-homepage URL.");
        navigate("/");
    } else {
        console.debug("User did not come directly.");
    }
  }, [location.pathname, navigate]);


  /*Message prompting for users to rotate device when accessing site
  via smartphone on portrait mode.*/ 
  
  // 1: Detect windowWidth and windowHeight, and save values.
  console.debug("Testing width in App.js: " + windowWidth);
  console.debug("Testing height in App.js: " + windowHeight);  

  const [resolution, setResolution] = useState({
    width: windowWidth,
    height: windowHeight
  });

  // 2: Create bool const to check if device is in portrait mode
  const [detectPort, setDetectPort] = useState(false);

  // Extra const
  const screenprompt = {
    frontlogo: BookofAbdulFrontLogo,
    logoalt1: "BookofAbdulFrontLogo",
    backlogo: BookofAbdulBackLogo,
    logoalt2: "BookofAbdulBackLogo",
    message: "Please rotate your device in order to view website. Mobile design coming soon!"
  }

  // 3: Check if width is smaller than 640p, and save bool to true if portrait mode is detected.
  useEffect(() => {
    const handleResize = () => {
      setResolution({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    // Resize window when resolution values change.
    window.addEventListener("resize", handleResize);

    // New edit: reinitialize new values of window resolution to export to PageAnimations.
    console.debug("Resolution.width: " + resolution.width);
    console.debug("Resolution.height: " + resolution.height);
    windowWidth = resolution.width;
    windowHeight = resolution.height;
    console.debug("New Values of Width: " + windowWidth);
    console.debug("New Values of Height: " + windowHeight);

    if (resolution.width < 640 && resolution.width < resolution.height) {
      console.debug("Portrait mode detected. Width Resolution: " + resolution.width);
      setDetectPort(true);
    } else {
      console.debug("Landscape detected. Width Resolution: " + resolution.width);
      setDetectPort(false);
    }

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [resolution]);

  return (
    <div className="Book-of-Abdul-Background" id="BoA-background-color"> 
    {/* 4: Conditionally render message if bool is true */}
      {detectPort && (
        <section className="BoA-portrait-message">
          <figure className="BoA-portrait-message-background">
            <img id="BoA-portrait-message-image" src={screenprompt.frontlogo} alt={screenprompt.logoalt1}/>
            <img id="BoA-portrait-message-image" src={screenprompt.backlogo} alt={screenprompt.logoalt2}/>
            <figcaption id="BoA-portrait-message-text">{screenprompt.message}</figcaption>
          </figure>
        </section>
      )}
      <main className="Book-of-Abdul-Layout">
      <Header />
        <Routes>
          <Route path={"/"} element={<Home />}/>
          <Route path={"/frontpage"} element={<FrontPage />}/>
          <Route path={"/tableofcontents"} element={<TableOfContents />}/>
          <Route path={"/artwork"} element={<Artwork />}/>
          <Route path={"/artwork-2"} element={<Artwork2 />}/>
          <Route path={"/artwork-3"} element={<Artwork3 />}/>
          <Route path={"/codingprojects"} element={<CodingProjects />}/>
          <Route path={"/codingprojects-2"} element={<CodingProjects2 />}/>
          <Route path={"/codingprojects-3"} element={<CodingProjects3 />}/>
          <Route path={"/codingprojects-4"} element={<CodingProjects4 />}/>
          <Route path={"/codingprojects-5"} element={<CodingProjects5 />}/>
          <Route path={"/writing"} element={<Writing />}/>
          <Route path={"/about"} element={<About />}/>
          <Route path={"/about-2"} element={<About2 />}/>
          <Route path={"/backpage"} element={<BackPage />}/>
          <Route path={"/backcover"} element={<BackCover />}/>
          <Route path={"*"} element={<Navigate to="/" />}/>
        </Routes>
        <Footer />
      </main>
    </div>
  );
}

export default App;


// Code that doesn't work (leaving here for now)

//   const [redirect, setRedirect] = useState(null);

/* Detecting whether user enters website through typing URL in browser,
and redirecting to homepage if done so. This is to preserve the state of 
the website.
useEffect(() => {
  if (document.referrer === "" && location.pathname !== "/") {
      console.debug("User came directly through non-homepage URL.");
      //navigate("/");
      setRedirect(true);
      console.debug("State location: " + location.state);
  } else {
      console.debug("User did not come directly.");
      console.debug(document.referrer);
      console.debug("State location: " + location.state);

  }
}, [location.pathname, location.state, redirect]);

          {redirect && 
            (<Route element={<Navigate to="/" />}/>
            )}

                return (
          <div className="BoA-alert-display" value={anime}>
            <span className="BoA-back-alert">
              <strong id="BoA-alert-text">Please use the buttons provided to navigate the contents of the book.
              </strong>
            </span>
          </div>
      )
*/